import { motion } from 'motion/react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  company: string;
}

export function TestimonialCard({ quote, author, role, company }: TestimonialCardProps) {
  return (
    <motion.div
      className="p-8 rounded-[2rem] bg-white border border-slate-100 shadow-sm hover:shadow-lg flex flex-col justify-between h-full hover:-translate-y-1.5 transition-all duration-300"
      whileHover={{ y: -6, boxShadow: '0 15px 30px rgba(37, 117, 252, 0.06)' }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <div>
        <motion.div
          className="text-3xl text-primary/70 mb-2 font-serif"
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          "
        </motion.div>
        <p className="text-slate-700 text-sm md:text-[15px] leading-relaxed mb-4 whitespace-normal break-words text-wrap">"{quote}"</p>
      </div>
      <div className="flex items-center gap-3 mt-auto">
        <motion.div
          className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center text-white font-bold text-base shadow-sm shrink-0"
          whileHover={{ scale: 1.1, rotate: 180 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          {author.charAt(0)}
        </motion.div>
        <div>
          <div className="text-slate-900 font-bold text-sm md:text-[15px]">{author}</div>
          <div className="text-xs text-slate-500 font-sans">
            {role} {company && `at ${company}`}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
